<script>
import { layoutComputed } from "@/state/helpers";
import Switches from "vue-switches";
import JsonForm from "./form";
import Multiselect from "vue-multiselect";

export default {
  props: [
    "page",
    "activeStatus",
    "locations",
    "activationStatus",
    "current_location",
  ],
  components: {
    Switches,
    JsonForm,
    Multiselect,
  },
  data() {
    return {
      filterValue: "",
      practices: [],
      selectPracticeFlag: false,
      enabled: this.activeStatus,
      formData: null,
      submitted: false,
      selectedPractices: [],
      selected_location: null,
      // locations: []
    };
  },
  computed: {
    ...layoutComputed,
    enableAddNewButton() {
      if (this.page.addNewBtn) {
        return this.page.addNewBtn;
      }
      return (
        (this.$route?.query?.devlopermode &&
          this.$route?.query?.devlopermode === "true") ||
        false
      );
    },
  },
  methods: {
    selectAllPractices() {
      for (let practice of this.allPractices) {
        this.selectedPractices.push(practice.id);
      }
    },
    selectPractice(val) {
      if (this.selectedPractices.includes(val.id)) {
        this.selectedPractices = this.selectedPractices.filter((n) => {
          return n != val.id;
        });
      } else {
        this.selectedPractices.push(val.id);
      }
    },
    submitForm() {
      this.$emit("form-submitted", true);
    },
    deleted() {
      this.$emit("deleted", true);
    },
    addNew() {
      this.$bvModal.hide("modal-center");
      if (this.page.title == "Users") {
        this.page.formData.practicesList = this.selectedPractices;
      }
      this.$emit("created", this.page.formData);
      this.page.formData = {};
    },
    uploadFile() {
      this.$bvModal.hide("modal-center");
      // console.log(this.page.fileSelected.files.item(0))
      // this.$emit('created', this.page.fileSelected.files.item(0));
      this.$emit("created", this.page);
    },
    editPage() {
      this.$emit("edit-page", true);
    },
    onHidden() {
      if (this.page.title == "Users") {
        this.selectPracticeFlag = !this.selectPracticeFlag;
      }
    },
    // async getLocations() {
    //   return await new Promise((resolve)=>{
    //     api.get(`/api/cms/${this.currentCms.id}/categories`)
    //     .then((response) => {
    //       var location_category = response.data.filter(x => x.name == 'Locations')[0];
    //         api.get(`/api/categories/${location_category.id}/pages`)
    //         .then((response) => {
    //           this.$emit('location-updated', response.data)
    //           resolve(response.data)
    //         }, (error) => {
    //           console.log(error);
    //         });
    //     }, (error) => {
    //       console.log(error);
    //     });
    //   });
    // },
    changeLocation() {
      this.$emit("location-updated", this.selected_location);
    },
  },
  watch: {
    current_location(val) {
      this.$emit("location-updated", val);
    },
    activationStatus() {
      if (this.activationStatus) {
        this.enabled = this.activeStatus;
        this.$emit("activation-status", false);
      }
    },
    activeStatus() {
      if (this.activeStatus != this.enabled) {
        this.enabled = this.activeStatus;
      }
    },
    enabled() {
      if (this.enabled != this.activeStatus) {
        this.$emit("activateToggle", true);
      }
    },
  },
  async mounted() {},
};
</script>

<template>
  <div
    class="navbar-header mt-4 border-bottom-dark px-4 pb-4"
    style="letter-spacing: 0.02em"
  >
    <div class="d-flex font-size-12 h-75">
      <i
        @click="$router.go(-1)"
        class="ri-arrow-left-line text-primary btn my-auto font-size-20 pl-0 py-0"
      ></i>
      <div class="d-flex align-items-center justify-content-between">
        <h2 class="mb-0 font-size-32 text-primary">{{ page.title }}</h2>
      </div>
      <!-- <div v-if="page.lastUpdated" class="d-flex align-items-center justify-content-between font-size-14 ml-4">
        <p class="mb-0"><span class="font-weight-medium">Last Updated: </span>{{page.lastUpdated}}</p>
      </div> -->
    </div>

    <div v-if="page.searchBox" class="col">
      <div
        id="tickets-table_filter"
        class="dataTables_filter text-md-right mt-2"
      >
        <label class="font-weight-medium d-inline-flex align-items-center w-75">
          Search:
          <b-form-input
            v-model="filterValue"
            type="search"
            :placeholder="
              page.title == 'Users' ? 'Name, email or practice' : 'Name or type'
            "
            class="form-control ml-2"
          >
          </b-form-input>
          <button
            class="btn btn-primary rounded-0 ml-2"
            @click="$emit('filter', filterValue)"
          >
            Search
          </button>
        </label>
      </div>
    </div>
    <div class="d-flex font-size-14 h-75">
      <div
        v-if="enableAddNewButton"
        class="d-flex align-items-center justify-content-between pl-3 border-right-dark"
      >
        <span class="font-weight-medium mb-0">Add New: </span>
        <!-- <i v-b-modal.modal-center class="ri-add-circle-fill text-primary align-self-center font-size-50 ml-2"></i> -->
        <img
          v-b-modal.modal-center
          class="align-self-center ml-2"
          src="@/assets/images/addbtngreen.svg"
          alt=""
        />
        <b-modal
          style="letter-spacing: 2em"
          id="modal-center"
          centered
          :title="page.addNewModalTitle"
          title-class="font-18"
          hide-footer
          @hidden="onHidden"
        >
          <JsonForm
            v-if="!selectPracticeFlag"
            :page="page"
            :schema="page.schema"
            :formData="page.formData"
          ></JsonForm>
          <div v-else class="overflow-auto mb-4">
            <a
              class="font-weight-bold pe-auto"
              v-on:click="selectAllPractices()"
              >Select All</a
            >
            <div style="height: 300px">
              <ul
                v-for="item of allPractices"
                v-bind:key="item.id"
                class="list-group list-group-flush"
              >
                <li
                  class="list-group-item border-top pl-0"
                  :class="
                    selectedPractices.includes(item.id) ? 'text-primary' : ''
                  "
                  v-on:click="selectPractice(item)"
                >
                  <img
                    v-if="selectedPractices.includes(item.id)"
                    class="align-self-center mr-3"
                    src="@/assets/images/active-tick.svg"
                    alt=""
                  />
                  <img
                    v-else
                    class="align-self-center mr-3"
                    src="@/assets/images/check-box.svg"
                    alt=""
                  />
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>

          <div v-if="page.title == 'Documents'">
            <b-button
              v-on:click="uploadFile"
              class="float-right"
              variant="primary"
              >Save</b-button
            >
          </div>
          <div v-else>
            <b-button
              v-if="page.title == 'Users'"
              variant="light"
              v-on:click="selectPracticeFlag = !selectPracticeFlag"
            >
              <span v-if="!selectPracticeFlag">Edit Practice</span>
              <span v-if="selectPracticeFlag">Go back</span>
            </b-button>
            <b-button
              v-if="!selectPracticeFlag"
              v-on:click="addNew"
              class="float-right"
              variant="primary"
              >Create</b-button
            >
          </div>
        </b-modal>
      </div>
      <div
        v-if="page.deleteBtn"
        class="d-flex align-items-center justify-content-between pl-3 border-right-dark"
      >
        <span class="font-weight-medium mb-0">Delete: </span>
        <!-- <i v-on:click="deleted" class="fas fa-trash-alt text-danger btn ml-2 my-auto font-size-30 p-1"></i> -->
        <img
          v-on:click="deleted"
          class="align-self-center ml-2 cursor-pointer"
          src="@/assets/images/delbtn.svg"
          alt=""
        />
      </div>
      <div
        v-if="page.activeBtn"
        class="d-flex align-items-center justify-content-between pl-3 border-right-dark"
      >
        <span class="font-weight-medium mb-0">Active: </span>
        <!-- <i class="ri-information-fill mx-2 my-auto font-size-18 text-muted"></i> -->
        <img
          id="info_tooltip"
          class="align-self-center mx-2"
          src="@/assets/images/info.svg"
          alt=""
        />
        <b-tooltip target="info_tooltip">Active Status</b-tooltip>

        <switches
          v-model="enabled"
          type-bold="false"
          color="info"
          class="ml-1 mt-4"
        ></switches>
      </div>
      <div
        v-if="page.submitBtn"
        class="font-size-14 font-weight-medium d-flex align-items-center justify-content-between ml-4 border-right-dark"
      >
        <b-button v-on:click="submitForm" class="px-4" variant="success"
          >Save</b-button
        >
      </div>
      <div
        v-if="page.editPageBtn"
        class="font-size-14 font-weight-medium d-flex align-items-center justify-content-between ml-4 border-right-dark"
      >
        <b-button v-on:click="editPage" class="px-4 btn-edit-page"
          ><img :src="require('@/assets/images/pen-icon.svg')" /> Edit</b-button
        >
      </div>
    </div>
    <div
      v-if="page.selectLocation"
      class="d-flex align-items-center justify-content-between w-25"
    >
      <span class="font-weight-medium mb-0">Location: </span>
      <div class="col">
        <multiselect
          track-by="title"
          label="title"
          v-model="current_location"
          :options="locations"
          :searchable="locations.length > 5 ? true : false"
          :close-on-select="true"
          :show-labels="false"
          :placeholder="'Select Location'"
          :allow-empty="false"
          :preselectFirst="true"
          open-direction="bottom"
        >
          <template slot="singleLabel" slot-scope="{ option }"
            ><strong>{{ option.title }}</strong></template
          >
        </multiselect>
      </div>
      <!-- <div class="col">
        <select class="form-control">
          <option>Select</option>
          <option>Farnham</option>
          <option>Lower Bourne</option>
        </select>
      </div> -->
    </div>
    <!-- <template>
  <select class="form-control" v-model="selected_location" @change="changeLocation">
    <option>Select Location</option>
    <option v-for="location in locations" v-bind:value="location.id" v-bind:key="location.id">{{ location.title }}</option>
 </select>
</template> -->
  </div>
</template>

<style scoped>
.border-bottom-dark {
  border-bottom: 1px solid #dadce3;
}
.border-right-dark:not(:last-of-type) {
  border-right: 1px solid #dadce3;
  border-radius: 0;
  padding-right: 16px;
}

.vue-switcher div:after {
  height: 23px;
  width: 23px;
  left: 95%;
}
.btn-success {
  background-color: #62c2a7;
  border-color: #62c2a7;
}

.btn-edit-page {
  background-color: #f45326;
  border-color: #f45326;
}

.vue-switcher--bold div {
  height: 30px !important;
  width: 50px !important;
}
.vue-switcher--bold div:after {
  margin-left: -27px !important;
  top: 3px !important;
}
</style>
